import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import "./index.css"
import "./i18n"
import App from "./App"
import { installObservability } from "./lib/observability"
import { applyInitialTheme } from "./lib/theme"

applyInitialTheme()
// PRD-57 FR-14 — before the first render, so a crash DURING render is seen.
// Cheap: it registers two listeners and a log sink; PostHog itself still
// loads lazily, on the first thing worth reporting.
installObservability()

const root = document.getElementById("root")
if (!root) throw new Error("Root element missing from index.html")

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
